import { render, staticRenderFns } from "./RecievedComponent.vue?vue&type=template&id=11b4663d&scoped=true&"
import script from "./RecievedComponent.vue?vue&type=script&lang=js&"
export * from "./RecievedComponent.vue?vue&type=script&lang=js&"
import style0 from "./RecievedComponent.vue?vue&type=style&index=0&id=11b4663d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b4663d",
  null
  
)

export default component.exports